import common from './common';

export default class SaveData {
	constructor() {
		this._data = {
			spine: {}
		};
		this.load();
	}

	save() {
		const data = JSON.stringify(this._data);
		const name = common.config.save.name + common.config.save.version;
		localStorage.setItem(name, data);
	}

	load() {
		const name = common.config.save.name + common.config.save.version;
		const data = localStorage.getItem(name);
		data && (this._data = JSON.parse(data));
	}

	getSpineHacks(name) {
		return this._data.spine[name];
	}

	saveSpineHacks(name, spine) {
		const data = this._data.spine[name] = {};
		const hacks = spine.hacks;

		for (const i in hacks) {
			if (hacks.hasOwnProperty(i)) {
				const hack = hacks[i];
				!data[hack.slotName] && (data[hack.slotName] = {
					offset: {x: hack.offset.x, y: hack.offset.y},
					path: hack.path.exportJSON()
				});
			}
		}
		this.save();
	}
}